export default __webpack_public_path__ + "static/media/hackathon.efcb595a.gif";